import { ResAddressDTO, ResAddressRestApiService } from '@tw/clvip-api-gen';
import { SettingCreateAddressLoadParam, SettingCreateAddressStoreState } from './type';

/*
 * Copyright (c) 2019 3will Corporation and others.
 * All rights reserved. This program and the accompanying materials
 * are made available under the terms of the 3will License v1.0
 * which accompanies this distribution, and is available at
 *
 *     http://www.3will.cn/licenses/license-v1.0
 *
 * Contributors:
 *    3will - initial API and implementation
 */
import { BfPageStore } from '@tw/tw-runtime';

export class SettingCreateAddressStore extends BfPageStore<SettingCreateAddressStoreState> {
  public addressService: ResAddressRestApiService;

  constructor() {
    super({
      pluginOptions: {
        devTools: {
          name: 'setting/createAddress'
        }
      }
    });
    this.addressService = new ResAddressRestApiService(this.appContext.getApiService());
  }

  async onLoad(params?: SettingCreateAddressLoadParam): Promise<void> {
    console.log('param: ', params);
    if (params.mode === 'edit') {
      this.setLoading(true);
      const address = await this.addressService.info({
        id: params.addressId
      });

      console.log('addresses: ', address);
      this.setState({
        data: address,
        mode: 'edit'
      });
      this.setLoading(false);
    } else {
      this.setState({
        mode: 'create'
      });
    }
  }
}
